import { useQuery } from '@tanstack/react-query';
import { GETAiNewsV2 } from '@fe-news/api/ai';
import { GETAiArticlesReturnResponseV2 } from '@fe-news/constants/ai/type';
import { NewsCategory } from '@fe-news/constants/categories';
import { fetchNewsById } from '@fe-news/services/news';

type UseAiNewsQueryProps = {
  type: NewsCategory.HEADLINE_AI | NewsCategory.TW_STOCK_AI | NewsCategory.WD_STOCK_AI;
  page: number;
  initialData?: GETAiArticlesReturnResponseV2;
};

const useAiNewsQuery = ({ type, page, initialData }: UseAiNewsQueryProps) => {
  const { data, isError, isFetching } = useQuery({
    queryKey: ['ai-news', type, page],
    queryFn: () => GETAiNewsV2({ type, page }),
    initialData: initialData
  });

  const newsId = data?.items?.data?.[0]?.newsId;

  const { data: newsData } = useQuery({
    queryKey: ['news', newsId],
    queryFn: () => fetchNewsById(newsId ?? 0)
  });

  const totalData = {
    ...data,
    related: newsData?.recommended
  };

  return { data: totalData, isError, isFetching };
};

export default useAiNewsQuery;
